import { render, staticRenderFns } from "./ktp.vue?vue&type=template&id=a3fea62e&scoped=true"
import script from "./ktp.vue?vue&type=script&lang=js"
export * from "./ktp.vue?vue&type=script&lang=js"
import style0 from "./ktp.vue?vue&type=style&index=0&id=a3fea62e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3fea62e",
  null
  
)

export default component.exports